import { Static, Object, Optional, String, Number, Composite } from '@sinclair/typebox';

import { UnionEnum } from '../../../utils/unionEnum';
import { TravelPassFlightOffersResponse } from '../travel-pass-flight-offers-api';

import { TravelPassApiAnyError } from './error';

export const TravelPassTicketSearchError = Object({
  errorMessage: Optional(String()),
  errorCode: Optional(String()),
});
export type TravelPassTicketSearchError = Static<typeof TravelPassTicketSearchError>;

export const TravelPassFlightsQuery = Object({
  origin: String(),
  destination: String(),
  productTypeCode: String(),
  outDate: Optional(String()),
  inDate: Optional(String()),
  adt: Optional(Number()),
  requestedBoundType: Optional(UnionEnum(['INBOUND', 'OUTBOUND', 'ROUND_TRIP'])),
  bookingClassCode: Optional(String()),
});
export type TravelPassFlightsQuery = Static<typeof TravelPassFlightsQuery>;

export const TravelPassFlightsError = TravelPassApiAnyError();

export type TravelPassFlightsError = Static<typeof TravelPassFlightsError>;

export const TravelPassFlightsResponse = Composite([TravelPassFlightOffersResponse, Object({ pos: String() })]);
export type TravelPassFlightsResponse = Static<typeof TravelPassFlightsResponse>;
